import { defineMessages, injectIntl } from 'react-intl';
import { MoreVert } from '@mui/icons-material';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import Button from '../../../components/common/Button';

const messages = defineMessages({
  EDIT_DASHBOARD: {
    id: 'DashboardUpdatePage.EDIT_DASHBOARD',
    defaultMessage: 'Edit dashboard',
  },
  LABEL_ADD_WIDGET: {
    id: 'DashboardSinglePage.LABEL_ADD_WIDGET',
    defaultMessage: 'Add widget',
  },
  LABEL_DONE: {
    id: 'DashboardSinglePage.LABEL_DONE',
    defaultMessage: 'Done',
  },
  LABEL_EDIT: {
    id: 'DashboardSinglePage.LABEL_EDIT',
    defaultMessage: 'Edit',
  },
  DOWNLOAD_TEMPLATE: {
    id: 'DashboardSinglePage.DOWNLOAD_TEMPLATE',
    defaultMessage:
      'Download this dashboard as a template. You can use this while creating a dashboard.',
  },
  SYNC_WITH_TEMPLATE: {
    id: 'DashboardSinglePage.SYNC_WITH_TEMPLATE',
    defaultMessage: 'advanced feature: sync with template',
  },
  SHARE_DASHBOARD: {
    id: 'DashboardSharingPage.SHARE_DASHBOARD',
    defaultMessage: 'Share dashboard',
  },
  COPY_DASHBOARD: {
    id: 'SelectUserDashboardForm.COPY_DASHBOARD',
    defaultMessage: 'Copy dashboard',
  },
  CANCEL: {
    id: 'DeleteForm.CANCEL',
    defaultMessage: 'Cancel',
  },
  CONFIRM: {
    id: 'DashboardContainerPage.ADD_USER_TO_ACCOUNT_CONFIRM',
    defaultMessage: 'Confirm',
  },
});

const StyledButton = styled(Button)`
  @media (max-width: 1125px) {
    & > i {
      margin: 0;
    }
    & > span {
      display: none;
    }
  }
`;
const ButtonDone = styled(StyledButton)``;
const ButtonChange = styled(StyledButton)``;
const ButtonAdd = styled(StyledButton)``;

const MoreButton = styled.button`
  color: ${({ theme }) => theme.color};
  border-radius: 0.2rem;
  border: none;
  padding: 0.2rem;
  margin-left: 0.5rem;
  background: ${({ theme }) => theme.button.default.backgroundColor};
  &:hover {
    background: ${({ theme }) => theme.button.default.backgroundHover};
  }
`;

// const SyncButton = styled.button`
//   color: ${({ theme }) => theme.color};
//   border-radius: 0.2rem;
//   border: none;
//   padding: 0.2rem;
//   margin-right: 0.5rem;
//   background: ${({ theme }) => theme.button.default.backgroundColor};
//   &:hover {
//     background: ${({ theme }) => theme.button.default.backgroundHover};
//   }
// `;

const DashboardControls = styled.div`
  color: ${({ theme }) => theme.color};
`;
const ContainerMore = styled.div`
  display: flex;
  position: absolute;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem;
  border-radius: 0.2rem;
  background: ${({ theme }) => theme.button.default.backgroundColor};
  box-shadow: ${({ theme }) => theme.header.boxShadow};
`;

function DashboardUpdateNavigationBar(props) {
  const {
    showMoreOptions,
    showMore,
    currentDashboard,
    windowWidth,
    intl: { formatMessage },
    show_edit,
    can_edit_dashboard = true,
    can_copy_dashboard = false,
    user,
    hasAdminRights = false,
    copyDashboard,
    is_distributor,
    setEditMode,
  } = props;

  let showShare = false;
  if ((hasAdminRights && currentDashboard.user_id === user.id) || is_distributor) {
    showShare = true;
  }

  if (show_edit === false) {
    window.location.assign(`/`);
    return null;
  }

  if (!can_edit_dashboard) {
    return null;
  }

  // Handle done button click - ONLY update state, no URL changes
  const handleDoneClick = () => {
    if (setEditMode) {
      setEditMode(false);
    }
  };

  return (
    <DashboardControls className="flex-auto flex pv2">
      <div className="flex-row flex align-center" style={{ position: 'relative' }}>
        <ButtonDone
          onClick={handleDoneClick}
          activestyle="success"
          title={formatMessage(messages.LABEL_DONE)}
          icon="fa fa-check"
          marginLeft
        />
        <ButtonAdd
          to={{
            pathname: `/dashboard/${currentDashboard.id}/widget/create_widget/`,
          }}
          title={formatMessage(messages.LABEL_ADD_WIDGET)}
          icon="fa fa-plus"
          activestyle="primary"
          marginLeft
        />
        {windowWidth >= 749 && (
          <ButtonChange
            to={{ pathname: `/dashboard/${currentDashboard.id}/update/` }}
            title={formatMessage(messages.EDIT_DASHBOARD)}
            icon="fas fa-cog"
            marginLeft
          />
        )}
        {windowWidth >= 749 && showShare && (
          <ButtonChange
            to={{ pathname: `/dashboard/${currentDashboard.id}/sharing/` }}
            title={formatMessage(messages.SHARE_DASHBOARD)}
            icon="fa fa-share-alt"
            marginLeft
          />
        )}
        {windowWidth >= 749 && can_copy_dashboard ? (
          <ButtonDone
            title={formatMessage(messages.COPY_DASHBOARD)}
            icon="fa fa-clone"
            onClick={() =>
              Swal.fire({
                title: currentDashboard.name,
                text: formatMessage(messages.COPY_DASHBOARD) + '?',
                showCancelButton: true,
                confirmButtonColor: '#019958',
                confirmButtonText: formatMessage(messages.CONFIRM),
                heightAuto: true,
                allowEscapeKey: true,
                allowEnterKey: false,
                cancelButtonText: formatMessage(messages.CANCEL),
                background: '#f2f3f5',
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  copyDashboard({
                    user_id: currentDashboard.user_id,
                    copy_dashboard_id: currentDashboard.id,
                  });
                }
              })
            }
            marginLeft
          />
        ) : null}
        {windowWidth >= 749 && (
          <>
            <Button
              component={({ children, ...rest }) => (
                <a title={formatMessage(messages.DOWNLOAD_TEMPLATE)} {...rest}>
                  {children}
                </a>
              )}
              href={`data:text/json;charset=utf-8,${encodeURIComponent(
                JSON.stringify(currentDashboard, null, 2)
              )}`}
              title={formatMessage(messages.DOWNLOAD_TEMPLATE)}
              data={currentDashboard}
              download={`dashboardconfig-${currentDashboard.id}-${currentDashboard.name}.json`}
              icon="fa fa-download"
              flat
              marginLeft
            />
          </>
        )}

        {/* Mobile View */}
        {windowWidth <= 749 && (
          <div style={{ position: 'relative' }}>
            <MoreButton onClick={showMoreOptions} type="button">
              <MoreVert />
            </MoreButton>
            {showMore && (
              <ContainerMore>
                <Button
                  to={{ pathname: `/dashboard/${currentDashboard.id}/update/` }}
                  title={formatMessage(messages.EDIT_DASHBOARD)}
                  icon="fa fa-pencil-alt"
                />
                {showShare && (
                  <Button
                    to={{ pathname: `/dashboard/${currentDashboard.id}/sharing/` }}
                    title={formatMessage(messages.SHARE_DASHBOARD)}
                    icon="fa fa-share-alt"
                  />
                )}
                {can_copy_dashboard && (
                  <Button
                    title={formatMessage(messages.COPY_DASHBOARD)}
                    icon="fa fa-clone"
                    onClick={() =>
                      Swal.fire({
                        title: currentDashboard.name,
                        text: formatMessage(messages.COPY_DASHBOARD) + '?',
                        showCancelButton: true,
                        confirmButtonColor: '#019958',
                        confirmButtonText: formatMessage(messages.CONFIRM),
                        heightAuto: true,
                        allowEscapeKey: true,
                        allowEnterKey: false,
                        cancelButtonText: formatMessage(messages.CANCEL),
                        background: '#f2f3f5',
                        reverseButtons: true,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          copyDashboard({
                            user_id: currentDashboard.user_id,
                            copy_dashboard_id: currentDashboard.id,
                          });
                        }
                      })
                    }
                    marginTop
                  />
                )}
                <Button
                  component={({ children, ...rest }) => (
                    <a title={formatMessage(messages.DOWNLOAD_TEMPLATE)} {...rest}>
                      {children}
                    </a>
                  )}
                  href={`data:text/json;charset=utf-8,${encodeURIComponent(
                    JSON.stringify(currentDashboard, null, 2)
                  )}`}
                  title={formatMessage(messages.DOWNLOAD_TEMPLATE)}
                  data={currentDashboard}
                  download={`dashboardconfig-${currentDashboard.id}-${currentDashboard.name}.json`}
                  icon="fa fa-download"
                  flat
                  marginTop
                />
              </ContainerMore>
            )}
          </div>
        )}
      </div>
    </DashboardControls>
  );
}

export default connect((state) => ({}))(injectIntl(DashboardUpdateNavigationBar));
